class CardVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    if (!this.select) return;
    this.select.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange() {
    const selected = this.select.options[this.select.selectedIndex];
    const card = this.closest('.card-wrapper') || this.closest('.card') || this.closest('.grid__item');
    if (!card) return;

    const price = selected.dataset.price || '';
    const comparePrice = selected.dataset.comparePrice || '';
    const available = selected.dataset.available === 'true';
    const isOnSale = comparePrice !== '' && comparePrice !== price;

    const priceContainer = card.querySelector('.price');
    if (!priceContainer) return;

    const regularContainer = priceContainer.querySelector('.price__regular');
    const saleContainer = priceContainer.querySelector('.price__sale');

    if (isOnSale && saleContainer) {
      // Show sale layout
      priceContainer.classList.add('price--on-sale');
      priceContainer.classList.remove('price--no-compare');

      if (regularContainer) regularContainer.style.display = 'none';
      saleContainer.style.display = '';

      // Ensure <s> tag with compare-at price exists
      let sTag = saleContainer.querySelector('s');
      if (!sTag) {
        sTag = document.createElement('s');
        sTag.className = 'price-item--compare';
        saleContainer.insertBefore(sTag, saleContainer.firstChild);
      }

      let compareSpan = sTag.querySelector('.price-item--regular');
      if (!compareSpan) {
        compareSpan = document.createElement('span');
        compareSpan.className = 'price-item price-item--regular';
        sTag.innerHTML = '';
        sTag.appendChild(compareSpan);
      }
      compareSpan.textContent = comparePrice;
      sTag.style.display = '';

      // Update sale price
      let saleEl = saleContainer.querySelector('.price-item--sale');
      if (!saleEl) {
        saleEl = document.createElement('span');
        saleEl.className = 'price-item price-item--sale';
        saleContainer.appendChild(saleEl);
      }
      saleEl.textContent = price;

    } else {
      // Show regular layout (no sale)
      priceContainer.classList.remove('price--on-sale');
      priceContainer.classList.add('price--no-compare');

      if (saleContainer) saleContainer.style.display = 'none';

      if (regularContainer) {
        regularContainer.style.display = '';
        let regularEl = regularContainer.querySelector('.price-item--regular');
        if (regularEl) regularEl.textContent = price;
      } else {
        // Fallback: update any price item found
        const anyPrice = priceContainer.querySelector('.price-item');
        if (anyPrice) anyPrice.textContent = price;
      }

      // Hide any leftover strikethrough
      const sTag = priceContainer.querySelector('s');
      if (sTag) sTag.style.display = 'none';
    }

    // Update hidden variant input for quick-add
    const hiddenInput = card.querySelector('.card-variant-input');
    if (hiddenInput) hiddenInput.value = selected.value;

    // Update button state
    const addButton = card.querySelector('.quick-add__submit, [name="add"]');
    if (addButton) {
      if (!available) {
        addButton.setAttribute('disabled', '');
        const btnText = addButton.querySelector('span');
        if (btnText) btnText.textContent = window.variantStrings?.soldOut || 'Sold out';
      } else {
        addButton.removeAttribute('disabled');
        const btnText = addButton.querySelector('span');
        if (btnText) btnText.textContent = window.variantStrings?.addToCart || 'Add to cart';
      }
    }
  }
}

if (!customElements.get('variant-selector')) {
  customElements.define('variant-selector', CardVariantSelector);
}